module.exports = __webpack_public_path__ + "img/wallets.56ee4954.svg";